"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upgradeablePlanIds = exports.SUBSCRIBE_TO_UNREAL_UNLIMITED_SUCCESS = exports.SWITCH_TO_ANNUAL_SUCCESS = exports.PAYMENT_INIT = exports.GET_PRICE = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = payments;
exports.initPayment = initPayment;
exports.setPaymentItem = setPaymentItem;
exports.setCurrentPaymentDeviceData = setCurrentPaymentDeviceData;
exports.setCurrentPaymentNonceAndBin = setCurrentPaymentNonceAndBin;
exports.setCurrentPaymentPaypalEmail = setCurrentPaymentPaypalEmail;
exports.cancelPaypalNonceAndEmail = cancelPaypalNonceAndEmail;
exports.setPaymentDone = setPaymentDone;
exports.setPaymentError = setPaymentError;
exports.purchaseWithExistingPaymentMethod = purchaseWithExistingPaymentMethod;
exports.updatePaymentMethod = updatePaymentMethod;
exports.submitPayment = submitPayment;
exports.preparePayment = preparePayment;
exports.preFinalizePayment = preFinalizePayment;
exports.finalizePayment = finalizePayment;
exports.paypalNonce = paypalNonce;
exports.creditCardNonce = creditCardNonce;
exports.teardownPayment = teardownPayment;
exports.getClientToken = getClientToken;
exports.getPrice = getPrice;
exports.getNextBillingPrice = getNextBillingPrice;
exports.validatePromocode = validatePromocode;
exports.applyPromocode = applyPromocode;
exports.resetPromocode = resetPromocode;
exports.resetPromocodeValidation = resetPromocodeValidation;
exports.getUpgradeParams = getUpgradeParams;
exports.switchToAnnualPlan = switchToAnnualPlan;
exports.subscribeToUnrealUnlimited = subscribeToUnrealUnlimited;

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _creditcards = require("creditcards");

var _reduxForm = require("redux-form");

var _utils = require("utils");

var _braintree = require("utils/braintree");

var _vat = require("./vat");

var _customer = require("./customer");

var _user = require("./user");

var _subscriptions = require("./subscriptions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import * as braintree from 'utils/braintree';
var GET_CLIENT_TOKEN = "ms/payments/get_client_token";
var GET_CLIENT_TOKEN_SUCCESS = "ms/payments/get_client_token_success";
var GET_CLIENT_TOKEN_FAIL = "ms/payments/get_client_token_fail";

var GET_PRICE = exports.GET_PRICE = "ms/payments/get_price";
var GET_PRICE_SUCCESS = "ms/payments/get_price_success";
var GET_PRICE_FAIL = "ms/payments/get_price_fail";

var GET_NEXT_BILLING_PRICE = "ms/payments/get_next_billing_price";
var GET_NEXT_BILLING_PRICE_SUCCESS = "ms/payments/get_next_billing_price_success";
var GET_NEXT_BILLING_PRICE_FAIL = "ms/payments/get_next_billing_price_fail";

var PAYMENT_INIT = exports.PAYMENT_INIT = "ms/payments/payment_init";
var PAYMENT_SUBMIT = "ms/payments/payment_submit";
var PAYMENT_DONE = "ms/payments/payment_done";
var PAYMENT_ERROR = "ms/payments/payment_error";

// const UPDATE_SETTINGS         = 'ms/payments/update_settings';
// const UPDATE_SETTINGS_SUCCESS = 'ms/payments/update_settings_success';
// const UPDATE_SETTINGS_FAIL    = 'ms/payments/update_settings_fail';

var CURRENT_PAYMENT_NONCE = "ms/payments/current_payment_nonce";
var CURRENT_PAYMENT_DEVICE_DATA = "ms/payments/current_payment_device_data";
var CURRENT_PAYMENT_PAYPAL_EMAIL = "ms/payments/current_payment_paypal_email";
var CANCEL_PAYMENT_PAYPAL_NONCE_AND_EMAIL = "ms/payments/cancel_payment_paypal_nonce_and_email";

var VALIDATE_PROMOCODE = "ms/payments/validate_promocode";
var VALIDATE_PROMOCODE_SUCCESS = "ms/payments/validate_promocode_success";
var VALIDATE_PROMOCODE_FAIL = "ms/payments/validate_promocode_fail";

var APPLY_PROMOCODE = "ms/payments/apply_promocode";
var APPLY_PROMOCODE_SUCCESS = "ms/payments/apply_promocode_success";
var APPLY_PROMOCODE_FAIL = "ms/payments/apply_promocode_fail";
var RESET_PROMOCODE = "ms/payments/reset_promocode";

var GET_UPGRADE_PARAMS = "ms/payments/get_upgrade_params";
var GET_UPGRADE_PARAMS_SUCCESS = "ms/payments/get_upgrade_params_success";
var GET_UPGRADE_PARAMS_FAIL = "ms/payments/get_upgrade_params_fail";

var SWITCH_TO_ANNUAL = "ms/payments/switch_to_annual";
var SWITCH_TO_ANNUAL_SUCCESS = exports.SWITCH_TO_ANNUAL_SUCCESS = "ms/payments/switch_to_annual_success";
var SWITCH_TO_ANNUAL_FAIL = "ms/payments/switch_to_annual_fail";

var RESET_VALIDATE_PROMO_CODE = "ms/payments/reset_validate_promo_code";

var PAYMENT_ITEM = "ms/payments/payment_item";

var SET_PAYMENT_ITEM = "ms/payments/set_payment_item";

var TEAR_DOWN_PAYMENT = "ms/payments/tear_down_payment";

var INIT_PAYPAL = "ms/payments/init_paypal";
var INIT_PAYPAL_SUCCESS = "ms/payments/init_paypal_success";
var INIT_PAYPAL_FAIL = "ms/payments/init_paypal_fail";

var INIT_CREDITCARD = "ms/payments/init_creditcart";
var INIT_CREDITCARD_SUCCESS = "ms/payments/init_creditcart_success";
var INIT_CREDITCARD_FAIL = "ms/payments/init_creditcart_fail";

var SUBSCRIBE_TO_UNREAL_UNLIMITED = "ms/payments/subscribe_to_unreal_unlimited";
var SUBSCRIBE_TO_UNREAL_UNLIMITED_SUCCESS = exports.SUBSCRIBE_TO_UNREAL_UNLIMITED_SUCCESS = "ms/payments/subscribe_to_unreal_unlimited_success";
var SUBSCRIBE_TO_UNREAL_UNLIMITED_FAIL = "ms/payments/subscribe_to_unreal_unlimited_fail";

var upgradeablePlanIds = exports.upgradeablePlanIds = ["hobby", "personal-4K", "personal-8K", "basic", "freelancer", "freelancer-8K", "freelancer-pro", "freelancer-8K-pro", "indie-game-4K", "indie-game-8K", "business-8K-500", "indie-annual", "indie-monthly", "personal-0-app", "personal-4K", "personal-annual", "personal-monthly", "pro-annual", "pro-monthly", "unreal-unlimited"];

var initialState = {
  clientToken: {},
  deviceData: {},
  nonces: {},
  price: {},
  nextBillingPrice: {},
  currentPayment: {},
  upgradeParams: {},
  activePromo: {},
  paypal: {},
  creditCard: {}
};

// Reducer

function payments() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case GET_PRICE:
      return (0, _extends3.default)({}, state, {
        price: (0, _extends3.default)({}, action.meta, { loading: true })
      });

    case GET_PRICE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        price: (0, _extends3.default)({}, action.meta, action.result, { loading: false })
      });

    case GET_PRICE_FAIL:
      return (0, _extends3.default)({}, state, {
        price: (0, _extends3.default)({}, action.meta, {
          loading: false,
          error: action.error
        })
      });

    case GET_NEXT_BILLING_PRICE:
      return (0, _extends3.default)({}, state, {
        nextBillingPrice: { loading: true }
      });

    case GET_NEXT_BILLING_PRICE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        nextBillingPrice: (0, _extends3.default)({}, action.result, { loading: false })
      });

    case GET_NEXT_BILLING_PRICE_FAIL:
      return (0, _extends3.default)({}, state, {
        nextBillingPrice: { error: action.error, loading: false }
      });

    case GET_CLIENT_TOKEN:
      return (0, _extends3.default)({}, state, {
        clientToken: {
          loading: false,
          error: ""
        }
      });

    case GET_CLIENT_TOKEN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        clientToken: (0, _extends3.default)({
          loading: false
        }, action)
      });
    case GET_CLIENT_TOKEN_FAIL:
      return (0, _extends3.default)({}, state, {
        clientToken: {
          loading: false,
          error: action.error.message
        }
      });

    case _vat.VALIDATE:
      return (0, _extends3.default)({}, state, {
        price: (0, _extends3.default)({}, state.price, {
          vatAmount: _ramda2.default.propOr(_ramda2.default.prop("vatAmount", state.price), "vatAmountOld", state.price),
          price: _ramda2.default.propOr(_ramda2.default.prop("price", state.price), "priceIncludingTax", state.price)
        })
      });

    case _vat.VALIDATE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        price: (0, _extends3.default)({}, state.price, {
          vatAmountOld: _ramda2.default.prop("vatAmount", state.price),
          vatAmount: 0,
          priceIncludingTax: _ramda2.default.prop("price", state.price),
          price: _ramda2.default.propOr(_ramda2.default.prop("price", state.price), "priceExcludingTax", state.price)
        })
      });

    case PAYMENT_INIT:
      return (0, _extends3.default)({}, state, {
        price: {},
        currentPayment: {
          done: false,
          paymentItem: action.payload.paymentItem
        }
      });

    case SET_PAYMENT_ITEM:
      return (0, _extends3.default)({}, state, {
        currentPayment: (0, _extends3.default)({}, state.currentPayment, {
          paymentItem: action.payload.paymentItem
        })
      });

    case PAYMENT_SUBMIT:
      return (0, _extends3.default)({}, state, {
        currentPayment: (0, _extends3.default)({}, state.currentPayment, {
          makingPayment: true,
          done: false,
          error: null,
          values: action.payload.values,
          singleUse: action.payload.singleUse,
          amount: action.payload.amount,
          cardLast4: action.payload.cardLast4
        })
      });

    case PAYMENT_DONE:
      return (0, _extends3.default)({}, state, {
        currentPayment: (0, _extends3.default)({}, state.currentPayment, {
          makingPayment: false,
          done: true
        })
      });

    case PAYMENT_ERROR:
      return (0, _extends3.default)({}, state, {
        currentPayment: (0, _extends3.default)({}, state.currentPayment, {
          makingPayment: false,
          done: false,
          error: action.payload.error
        })
      });

    case CURRENT_PAYMENT_NONCE:
      return (0, _extends3.default)({}, state, {
        currentPayment: (0, _extends3.default)({}, state.currentPayment, {
          nonce: action.payload.nonce,
          threeDNonce: action.payload.threeDNonce
        })
      });

    case CURRENT_PAYMENT_DEVICE_DATA:
      return (0, _extends3.default)({}, state, {
        currentPayment: (0, _extends3.default)({}, state.currentPayment, {
          // @TODO set actual device data after configuring with braintree properly
          deviceData: action.payload.deviceData
        })
      });

    case CURRENT_PAYMENT_PAYPAL_EMAIL:
      return (0, _extends3.default)({}, state, {
        currentPayment: (0, _extends3.default)({}, state.currentPayment, {
          paypalEmail: action.payload.email
        })
      });

    case CANCEL_PAYMENT_PAYPAL_NONCE_AND_EMAIL:
      return (0, _extends3.default)({}, state, {
        currentPayment: (0, _extends3.default)({}, state.currentPayment, {
          paypalEmail: undefined,
          nonce: undefined
        })
      });

    case VALIDATE_PROMOCODE:
      return (0, _extends3.default)({}, state, {
        currentPayment: (0, _extends3.default)({}, state.currentPayment, action.meta && {
          promoCode: {
            validatingPromocode: true
          }
        })
      });

    case VALIDATE_PROMOCODE_SUCCESS:
      var _res = action.result;
      return (0, _extends3.default)({}, state, {
        currentPayment: (0, _extends3.default)({}, state.currentPayment, action.meta && {
          promoCode: {
            planId: action.meta.planId,
            planPrice: _res.planPrice,
            validatingPromocode: false,
            message: _res.message || null,
            promoCode: _res.signedPromocodeInstance && _res.signedPromocodeInstance.code ? _res.signedPromocodeInstance.code : null,
            signedPromocodeInstance: _res.signedPromocodeInstance || null,
            discount: _res.discount,
            discountValue: _res.discountValue,
            discountedPrice: _res.discountedPrice,
            validated: true
          }
        })
      });

    case VALIDATE_PROMOCODE_FAIL:
      return (0, _extends3.default)({}, state, {
        currentPayment: (0, _extends3.default)({}, state.currentPayment, action.meta && {
          promoCode: {
            validatingPromocode: false,
            validationError: action.error
          }
        })
      });

    case APPLY_PROMOCODE:
      // let data = activePromo
      return (0, _extends3.default)({}, state, {
        activePromo: (0, _extends3.default)({}, state.activePromo, {
          code: action.meta.promoCode,
          applyingPromo: true,
          error: null,
          message: null
        })
      });
    case RESET_PROMOCODE:
      // let data = activePromo
      return (0, _extends3.default)({}, state, {
        activePromo: {}
      });

    case APPLY_PROMOCODE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        activePromo: (0, _extends3.default)({}, action.result.activePromo, {
          error: action.result.isError ? action.result.msg || action.result.message : null,
          message: !action.result.isError && typeof action.result.activePromo.message !== "undefiend" ? action.result.activePromo.message : null,
          applyingPromo: false,
          code: action.meta.promoCode
        })
      });

    case APPLY_PROMOCODE_FAIL:
      return (0, _extends3.default)({}, state, {
        activePromo: {
          applyingPromo: false,
          error: action.result.isError && (action.result.msg || action.result.message) || action.result,
          message: null,
          code: action.meta.promoCode
        }
      });
    case RESET_VALIDATE_PROMO_CODE:
      return (0, _extends3.default)({}, state, {
        currentPayment: (0, _extends3.default)({}, _ramda2.default.omit(["promoCode"], state.currentPayment))
      });

    case GET_UPGRADE_PARAMS:
      return (0, _extends3.default)({}, state, {
        switchedToAnnualPlan: false,
        upgradeParams: {
          fetchingParams: true
        }
      });

    case GET_UPGRADE_PARAMS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        upgradeParams: (0, _extends3.default)({}, action.result, {
          fetchingParams: false
        })
      });

    case GET_UPGRADE_PARAMS_FAIL:
      return (0, _extends3.default)({}, state, {
        upgradeParams: (0, _extends3.default)({}, action.result, {
          fetchingError: action.result,
          fetchingParams: false
        })
      });

    case SWITCH_TO_ANNUAL:
      return (0, _extends3.default)({}, state, {
        switchingToAnnual: true,
        switchedToAnnualPlan: false
      });

    case SWITCH_TO_ANNUAL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        switchingToAnnual: false,
        switchedToAnnualPlan: true
      });

    case SWITCH_TO_ANNUAL_FAIL:
      return (0, _extends3.default)({}, state, {
        switchingToAnnualError: action.result,
        switchingToAnnual: false,
        switchedToAnnualPlan: false
      });

    case INIT_PAYPAL:
      return (0, _extends3.default)({}, state, {
        paypal: {
          initializing: true
        }
      });

    case INIT_PAYPAL_SUCCESS:
    case INIT_PAYPAL_FAIL:
      return (0, _extends3.default)({}, state, {
        paypal: {
          initializing: false
        }
      });

    case INIT_CREDITCARD:
      return (0, _extends3.default)({}, state, {
        creditCard: {
          initializing: true
        }
      });

    case INIT_CREDITCARD_SUCCESS:
    case INIT_CREDITCARD_FAIL:
      return (0, _extends3.default)({}, state, {
        creditCard: {
          initializing: false
        }
      });

    case TEAR_DOWN_PAYMENT:
      return initialState;

    default:
      return state;
  }
}

// Action creators

function initPayment(paymentItem) {
  return {
    type: PAYMENT_INIT,
    payload: { paymentItem: paymentItem }
  };
}

function setPaymentItem(paymentItem) {
  return {
    type: SET_PAYMENT_ITEM,
    payload: { paymentItem: paymentItem }
  };
}

function setCurrentPaymentDeviceData(deviceData) {
  return {
    type: CURRENT_PAYMENT_DEVICE_DATA,
    payload: { deviceData: deviceData }
  };
}

function setCurrentPaymentNonceAndBin(_ref) {
  var nonce = _ref.nonce,
      bin = _ref.bin;

  return {
    type: CURRENT_PAYMENT_NONCE,
    payload: { nonce: nonce, bin: bin }
  };
}

function setCurrentPaymentPaypalEmail(email) {
  return {
    type: CURRENT_PAYMENT_PAYPAL_EMAIL,
    payload: { email: email }
  };
}

function cancelPaypalNonceAndEmail() {
  return {
    type: CANCEL_PAYMENT_PAYPAL_NONCE_AND_EMAIL
  };
}

function setPaymentDone() {
  return {
    type: PAYMENT_DONE
  };
}

function setPaymentError(error) {
  switch (error.message) {
    case 'child "paymentMethodNonce" fails because ["paymentMethodNonce" is required]':
      error.error = "Authorization not found";
      break;
    default:
      break;
  }

  return {
    type: PAYMENT_ERROR,
    payload: { error: error }
  };
}

function purchaseWithExistingPaymentMethod(_ref2) {
  var values = _ref2.values,
      singleUse = _ref2.singleUse,
      amount = _ref2.amount,
      paymentActionCreator = _ref2.paymentActionCreator;

  return function (dispatch, getState) {
    var state = getState();
    var customer = state.customer.customer;
    var countryCode = customer.countryCode,
        customerState = customer.state;


    if (countryCode === "US" && !customerState) {
      var message = "Please specify your state by going to Change Billing Details.";

      var error = new Error(message);
      error._error = message;
      return _bluebird2.default.reject(error);
    }

    var vatNo = getState().customer.customer.vatNo;
    var price = _ramda2.default.path(["price", vatNo && values.countryCode !== "SE" ? "priceExcludingTax" : "price"], getState().payments);
    var finalAmount = typeof price !== "undefined" && price !== null ? price : amount;

    dispatch({
      type: PAYMENT_SUBMIT,
      payload: {
        values: customer,
        singleUse: singleUse,
        amount: finalAmount
      }
    });

    var paymentValues = {
      vatNo: customer.vatNo,
      postalCode: customer.postalCode,
      countryCode: customer.countryCode,
      address1: customer.address1,
      address2: customer.address2,
      amount: finalAmount
    };

    return dispatch((0, _customer.getCustomer)()).then(function (refetchedCustomer) {
      var paymentMethod = refetchedCustomer.paymentMethod;
      var email = state.user.email;
      var paymentMethodInstrument = customer.paymentMethod.paymentMethodInstrument;

      if (paymentMethodInstrument === "creditCard" && paymentMethod.paymentMethodNonce) {
        var _paymentMethod$paymen = paymentMethod.paymentMethodNonce,
            nonce = _paymentMethod$paymen.nonce,
            bin = _paymentMethod$paymen.details.bin;


        try {
          return dispatch(finalizePayment({
            paymentValues: (0, _extends3.default)({}, paymentValues, {
              paymentMethod: "cc",
              email: email,
              nonce: nonce,
              bin: bin,
              token: paymentMethod.token
            }),
            paymentActionCreator: paymentActionCreator
          }));
        } catch (e) {
          console.error(e);
        }
      } else {
        return dispatch(finalizePayment({
          paymentValues: (0, _extends3.default)({}, paymentValues, {
            token: _ramda2.default.path(["paymentMethod", "token"], refetchedCustomer)
          }),
          paymentActionCreator: paymentActionCreator
        }));
      }
    }).then(function () {
      dispatch(setPaymentDone());
      return dispatch((0, _user.load)(true));
    }).catch(function (error) {
      // @TODO development log
      dispatch(setPaymentError(error));
      error._error = error.msg || error.code || error.error;
      throw error;
    });
  };
}

function updatePaymentMethod(_ref3) {
  var values = _ref3.values;

  return function (dispatch, getState) {
    dispatch({
      type: _customer.UPDATE_PAYMENT_METHOD,
      payload: {
        values: sanitizeValues(values),
        cardLast4: getCardLast4(values)
      }
    });

    var preCustomer = getState().customer.customer;

    var customer = _ramda2.default.omit(["paymentMethod"])(getState().customer.customer);

    return _bluebird2.default.try(function () {
      if (values.paymentMethod === "cc") {
        var deviceData = (0, _braintree.getCreditCardDeviceData)("sandbox");
        dispatch(setCurrentPaymentDeviceData(deviceData));
        var _getState$payments$cu = getState().payments.currentPayment,
            nonce = _getState$payments$cu.nonce,
            bin = _getState$payments$cu.bin;


        return dispatch((0, _customer.createOrUpdateCustomer)((0, _extends3.default)({}, customer, { deviceData: "abc", nonce: nonce, bin: bin })));
      } else {
        var currentPayment = getState().payments.currentPayment;
        var paymentDetails = {
          nonce: currentPayment.nonce,
          // @TODO set actual device data after configuring with braintree properly
          deviceData: "abc"
        };

        return dispatch((0, _customer.createOrUpdateCustomer)((0, _extends3.default)({}, customer, paymentDetails)));
      }
    }).then(function (customer) {
      var paymentMethod = customer.paymentMethod;
      var address1 = customer.address1,
          address2 = customer.address2,
          country = customer.country,
          countryCode = customer.countryCode,
          name = customer.name,
          postalCode = customer.postalCode;
      var token = paymentMethod.token,
          paymentMethodNonce = paymentMethod.paymentMethodNonce;
      var nonce = paymentMethodNonce.nonce,
          bin = paymentMethodNonce.details.bin;


      var user = getState().user;
      var email = user.email,
          subscription = user.subscription;


      if (!subscription || subscription && subscription.isActive === false) {
        return dispatch({ type: _customer.UPDATE_PAYMENT_METHOD_SUCCESS });
      }

      var amount = subscription && subscription.amount;

      return dispatch(finalizePayment({
        paymentValues: {
          email: email,
          amount: amount,
          name: name,
          address1: address1,
          address2: address2,
          country: country,
          countryCode: countryCode,
          postalCode: postalCode,
          token: token,
          nonce: nonce,
          bin: bin,
          paymentMethod: paymentMethod.paymentMethodInstrument === "creditCard" ? "cc" : "paypal"
        },

        paymentActionCreator: _subscriptions.updateSubscriptionPaymentMethod
      }));
    }).then(function () {
      return dispatch({ type: _customer.UPDATE_PAYMENT_METHOD_SUCCESS });
    }).catch(function (error) {
      // @TODO development log
      dispatch({
        type: _customer.UPDATE_PAYMENT_METHOD_VALUES,
        result: preCustomer.paymentMethod
      });
      dispatch({
        type: _customer.UPDATE_PAYMENT_METHOD_ERROR,
        payload: error.msg
      });

      error._error = error.code || error.error;
      throw error;
    });
  };
}

function submitPayment(_ref4) {
  var values = _ref4.values,
      singleUse = _ref4.singleUse,
      amount = _ref4.amount,
      paymentActionCreator = _ref4.paymentActionCreator;

  return function (dispatch) {
    dispatch({
      type: PAYMENT_SUBMIT,
      payload: {
        values: sanitizeValues(values),
        singleUse: singleUse,
        amount: amount,
        cardLast4: getCardLast4(values)
      }
    });
    return dispatch(preparePayment({ values: values, singleUse: singleUse, amount: amount, paymentActionCreator: paymentActionCreator })).then(function () {
      dispatch(setPaymentDone());
      return dispatch((0, _user.load)(true));
    }).catch(function (error) {
      // @TODO development log
      dispatch(setPaymentError(error));

      error._error = error.code || error.error;
      throw error;
    });
  };
}

function preparePayment(_ref5) {
  var values = _ref5.values,
      singleUse = _ref5.singleUse,
      amount = _ref5.amount,
      paymentActionCreator = _ref5.paymentActionCreator;

  return function (dispatch) {
    return dispatch(preFinalizePayment({
      values: sanitizeValues(values),
      amount: amount,
      singleUse: singleUse,
      paymentActionCreator: paymentActionCreator
    }));
  };
}

function preFinalizePayment(_ref6) {
  var values = _ref6.values,
      singleUse = _ref6.singleUse,
      amount = _ref6.amount,
      paymentActionCreator = _ref6.paymentActionCreator;

  return function (dispatch, getState) {
    return _bluebird2.default.try(function () {
      // @TODO set actual device data after configuring with braintree properly
      var deviceData = getState().payments.currentPayment.deviceData || "abc";
      var _getState$payments$cu2 = getState().payments.currentPayment,
          nonce = _getState$payments$cu2.nonce,
          bin = _getState$payments$cu2.bin;


      var vat = getState().vat[values.vatNo];
      var vatNo = vat && vat.vatNo.replace(/\s/g, "");
      var vatSignature = vat && vat.signature;
      var country = (0, _utils.getCountryName)(values.country);
      var countryCode = values.country;
      var address1 = values.address;
      var address2 = values.address2;
      var state = values.state;
      var city = values.city;
      // For sweden we always charge VAT
      var price = _ramda2.default.path(["price", vatSignature && countryCode !== "SE" ? "priceExcludingTax" : "price"], getState().payments);
      var finalAmount = typeof price !== "undefined" && price !== null ? price : amount;

      var paymentValues = (0, _extends3.default)({}, values, {
        vatNo: vatNo,
        vatSignature: vatSignature,
        country: country,
        countryCode: countryCode,
        address1: address1,
        address2: address2,
        deviceData: deviceData,
        nonce: nonce,
        bin: bin,
        state: state,
        city: city,
        amount: finalAmount
      });

      if (!singleUse) {
        return dispatch((0, _customer.createOrUpdateCustomer)(paymentValues)).then(function () {
          return dispatch((0, _customer.getCustomer)());
        }).then(function (refetchedCustomer) {
          return (0, _extends3.default)({}, paymentValues, {
            nonce: _ramda2.default.path(["paymentMethod", "paymentMethodNonce", "nonce"], refetchedCustomer),
            bin: _ramda2.default.path(["paymentMethod", "paymentMethodNonce", "details", "bin"], refetchedCustomer),
            token: _ramda2.default.path(["paymentMethod", "token"], refetchedCustomer)
          });
        });
      } else {
        return paymentValues;
      }
    }).then(function (paymentValues) {
      return dispatch(finalizePayment({
        paymentValues: paymentValues,
        singleUse: singleUse,
        paymentActionCreator: paymentActionCreator
      }));
    });
  };
}

function finalizePayment(_ref7) {
  var paymentValues = _ref7.paymentValues,
      paymentActionCreator = _ref7.paymentActionCreator;

  return function (dispatch, getState) {
    return _bluebird2.default.try(function () {
      if (paymentValues.paymentMethod === "cc") {
        var currentPayment = getState().payments.currentPayment;

        var planId = "subscription-plan";
        if (currentPayment && Object.prototype.hasOwnProperty.call(currentPayment, "id")) {
          planId = "refill-subscription";
        } else if (currentPayment && Object.prototype.hasOwnProperty.call(currentPayment, "type")) {
          planId = "subscription-plan";
        }

        return dispatch(getClientToken({
          transactionType: planId,
          countryCode: paymentValues["countryCode"] || "US"
        })).then(function (_ref8) {
          var clientToken = _ref8.clientToken;
          return (0, _braintree.threeDSecureVerifyCard)((0, _extends3.default)({}, paymentValues, {
            address: paymentValues.address1,
            city: paymentValues.address2,
            country: paymentValues.countryCode,
            clientToken: clientToken
          })).then(function (threeDNonce) {
            return (0, _extends3.default)({}, paymentValues, {
              threeDNonce: threeDNonce
            });
          });
        });
      }

      return paymentValues;
    }).then(function (values) {
      return dispatch(paymentActionCreator(values));
    });
  };
}

function paypalNonce(_ref9) {
  var container = _ref9.container,
      singleUse = _ref9.singleUse,
      amount = _ref9.amount,
      currency = _ref9.currency,
      countryCode = _ref9.countryCode;

  return function (dispatch, getState) {
    var initializing = getState().payments.paypal.initializing;
    var _getState$payments$cu3 = getState().payments.currentPayment,
        paypalEmail = _getState$payments$cu3.paypalEmail,
        nonce = _getState$payments$cu3.nonce,
        paymentItem = _getState$payments$cu3.paymentItem;


    if (initializing || paypalEmail && nonce) {
      return;
    }

    dispatch({
      type: INIT_PAYPAL
    });

    var planId = "subscription-plan";

    if (paymentItem && paymentItem["id"]) {
      planId = "refill-subscription";
    } else if (paymentItem && paymentItem["type"]) {
      planId = "subscription-plan";
    }

    dispatch(getClientToken({
      transactionType: planId,
      countryCode: countryCode || "US"
    })).then(function (res) {
      dispatch((0, _braintree.initPayPal)({
        container: container,
        singleUse: singleUse,
        amount: amount,
        currency: currency,
        clientToken: res.clientToken,
        setDeviceData: function setDeviceData(deviceData) {
          return dispatch(setCurrentPaymentDeviceData(deviceData));
        },
        setNonce: function setNonce(nonce) {
          return dispatch(setCurrentPaymentNonceAndBin({ nonce: nonce }));
        },
        setPaypalEmail: function setPaypalEmail(email) {
          return dispatch(setCurrentPaymentPaypalEmail(email));
        }
        /* cancelPaypalNonceAndEmail: () => dispatch(cancelPaypalNonceAndEmail()), */
      })).then(function () {
        dispatch({
          type: INIT_PAYPAL_SUCCESS
        });
      });
    }).catch(function (_) {
      // TODO: development log

      dispatch({
        type: INIT_PAYPAL_FAIL
      });
    });
  };
}

function creditCardNonce(reInitializeForm) {
  return function (dispatch, getState) {
    var initializing = getState().payments.creditCard.initializing;
    var _getState$payments$cu4 = getState().payments.currentPayment,
        nonce = _getState$payments$cu4.nonce,
        paymentItem = _getState$payments$cu4.paymentItem;
    var customer = getState().customer.customer;


    (0, _braintree.getCreditCardDeviceData)("sandbox").then(function (res) {
      dispatch(setCurrentPaymentDeviceData(res));
    });

    if (!reInitializeForm && (initializing || nonce)) {
      return;
    }

    dispatch({
      type: INIT_CREDITCARD
    });

    var planId = "subscription-plan";

    if (paymentItem && paymentItem["id"]) {
      planId = "refill-subscription";
    } else if (paymentItem && paymentItem["type"]) {
      planId = "subscription-plan";
    }

    var countryCode = reInitializeForm && reInitializeForm.countryCode;

    dispatch(getClientToken({
      transactionType: planId,
      countryCode: countryCode || "US",
      getNewToken: true
    })).then(function (res) {
      dispatch((0, _braintree.initCreditCard)({
        clientToken: res.clientToken,
        setNonce: function setNonce(_ref10) {
          var nonce = _ref10.nonce,
              bin = _ref10.bin;

          return dispatch(setCurrentPaymentNonceAndBin({ nonce: nonce, bin: bin }));
        }
      })).then(function () {
        dispatch({
          type: INIT_CREDITCARD_SUCCESS
        });
      });
    }).catch(function (err) {
      // TODO: development log

      dispatch({
        type: INIT_CREDITCARD_FAIL
      });
    });
  };
}

function teardownPayment() {
  return {
    type: TEAR_DOWN_PAYMENT
  };
}

function getClientToken(_ref11) {
  var transactionType = _ref11.transactionType,
      countryCode = _ref11.countryCode,
      getNewToken = _ref11.getNewToken;

  return function (dispatch, getState) {
    var _getState = getState(),
        payments = _getState.payments,
        form = _getState.form;

    var clientToken = _ramda2.default.path(["clientToken", "result", "clientToken"], payments);

    if (clientToken && !getNewToken) {
      return _bluebird2.default.resolve({ clientToken: clientToken });
    }

    var _getValues = (0, _reduxForm.getValues)(form.checkout),
        captcha = _getValues.captcha;

    if (!captcha) {
      var error = new Error('Please select "I\'m not a robot" in the captcha box');

      dispatch({
        error: error,
        type: GET_CLIENT_TOKEN_FAIL
      });

      return _bluebird2.default.reject(error);
    }

    return dispatch({
      types: [GET_CLIENT_TOKEN, GET_CLIENT_TOKEN_SUCCESS, GET_CLIENT_TOKEN_FAIL],
      promise: function promise(client) {
        var payload = {
          captchaResponse: captcha,
          transactionType: transactionType,
          countryCode: countryCode
        };
        return client.post("/v1/payments/tokens", { data: payload }).then(function (res) {
          return res;
        });
      }
    });
  };
}

function getPrice(_ref12) {
  var price = _ref12.price,
      countryCode = _ref12.countryCode,
      state = _ref12.state,
      postalCode = _ref12.postalCode,
      vatNo = _ref12.vatNo,
      transactionType = _ref12.transactionType;

  return {
    types: [GET_PRICE, GET_PRICE_SUCCESS, GET_PRICE_FAIL],
    meta: { price: price, countryCode: countryCode, vatNo: vatNo, transactionType: transactionType },
    promise: function promise(client) {
      return client.post("v1/payments/price", {
        data: vatNo ? {
          price: price,
          countryCode: countryCode,
          vatNo: vatNo,
          transactionType: transactionType
        } : countryCode === "US" ? {
          price: price,
          countryCode: countryCode,
          state: state,
          postalCode: postalCode,
          transactionType: transactionType
        } : countryCode === "CA" ? {
          price: price,
          countryCode: countryCode,
          postalCode: postalCode,
          transactionType: transactionType
        } : {
          price: price,
          countryCode: countryCode,
          transactionType: transactionType
        }
      });
    }
  };
}

function getNextBillingPrice() {
  return {
    types: [GET_NEXT_BILLING_PRICE, GET_NEXT_BILLING_PRICE_SUCCESS, GET_NEXT_BILLING_PRICE_FAIL],
    promise: function promise(client) {
      return client.post("v1/payments/nextBillingPrice");
    }
  };
}

function validatePromocode(_ref13) {
  var promoCode = _ref13.promoCode;

  return function (dispatch, getState) {
    var currentPayment = getState().payments.currentPayment;
    var planId = currentPayment && currentPayment.paymentItem ? currentPayment.paymentItem.type : null;
    if (!planId) return;

    // const previousValidation = currentPayment.promoCode;
    // if (previousValidation && previousValidation.validated === true && previousValidation.promoCode === promoCode) {
    //   // dispatch({type: VALIDATE_PROMOCODE_SUCCESS});
    //   return BPromise.resolve(previousValidation);
    // }

    return dispatch({
      types: [VALIDATE_PROMOCODE, VALIDATE_PROMOCODE_SUCCESS, VALIDATE_PROMOCODE_FAIL],
      meta: { planId: planId, promoCode: promoCode },
      promise: function promise(client) {
        return client.post("v1/payments/promocode", {
          data: { planId: planId, promocode: promoCode }
        }).then(function (result) {
          if (!result.signedPromocodeInstance || !result.signedPromocodeInstance.signature) {
            throw new Error();
          }

          return result;
        });
      }
    });
  };
}
function applyPromocode(promoCode) {
  return function (dispatch, getState) {
    return dispatch({
      types: [APPLY_PROMOCODE, APPLY_PROMOCODE_SUCCESS, APPLY_PROMOCODE_FAIL],
      meta: { promoCode: promoCode },
      promise: function promise(client) {
        return client.post("v1/payments/applyPromo", { data: { promocode: promoCode } }).then(function (result) {
          dispatch((0, _user.load)(true));
          return result;
        }).error(function (e) {
          return e;
        });
      }
    });
  };
}
function resetPromocode(promoCode) {
  return function (dispatch) {
    return dispatch({
      type: RESET_PROMOCODE
    });
  };
}
function resetPromocodeValidation() {
  return function (dispatch) {
    return dispatch({
      type: RESET_VALIDATE_PROMO_CODE
    });
  };
}

function getUpgradeParams() {
  return function (dispatch, getState) {
    var user = getState().user;
    if (!user || !user.subscription || user.subscription.billing !== "monthly" || user.subscription.doesGetCharged === false || user.subscription.status.toLowerCase() !== "active") return;
    if (upgradeablePlanIds.indexOf(user.subscription.planId) === -1) return;

    return dispatch({
      types: [GET_UPGRADE_PARAMS, GET_UPGRADE_PARAMS_SUCCESS, GET_UPGRADE_PARAMS_FAIL],
      promise: function promise(client) {
        return client.post("/v1/payments/plans/annual/params").catch(function (e) {});
      }
    });
  };
}

function switchToAnnualPlan(amount) {
  return function (dispatch, getState) {
    var state = getState();
    var customer = state.customer.customer;
    var paymentMethod = customer.paymentMethod;
    var address1 = customer.address1,
        address2 = customer.address2,
        country = customer.country,
        countryCode = customer.countryCode,
        name = customer.name,
        postalCode = customer.postalCode;


    var user = state.user;
    var email = user.email;


    return dispatch((0, _customer.getCustomer)()).then(function (refetchedCustomer) {
      return dispatch(finalizePayment({
        paymentValues: {
          amount: amount,

          name: name,
          nonce: _ramda2.default.path(["paymentMethod", "paymentMethodNonce", "nonce"], refetchedCustomer),
          bin: _ramda2.default.path(["paymentMethod", "paymentMethodNonce", "details", "bin"], refetchedCustomer),
          address1: address1,
          address2: address2,
          email: email,
          postalCode: postalCode,
          country: country,
          countryCode: countryCode,

          paymentMethod: paymentMethod.paymentMethodInstrument === "creditCard" ? "cc" : "paypal",
          token: _ramda2.default.path(["paymentMethod", "token"], refetchedCustomer)
        },
        paymentActionCreator: confirmSwitchToAnnual
      }));
    });
  };
}

function confirmSwitchToAnnual(_ref14) {
  var amount = _ref14.amount,
      threeDNonce = _ref14.threeDNonce;

  return function (dispatch) {
    return dispatch({
      types: [SWITCH_TO_ANNUAL, SWITCH_TO_ANNUAL_SUCCESS, SWITCH_TO_ANNUAL_FAIL],
      promise: function promise(client) {
        return client.post("/v1/payments/plans/annual/switch", {
          data: { amount: amount, paymentMethod3DNonce: threeDNonce }
        }).then(function (result) {
          if (result.isError) {
            throw new Error();
          }
          return result;
        });
      }
    });
  };
}

function subscribeToUnrealUnlimited() {
  return function (dispatch, getState) {
    var state = getState();
    var user = state.user;
    var subscription = user.subscription;

    var hasSubscription = subscription && subscription.isActive;

    if (hasSubscription) {
      return dispatch({
        types: [SUBSCRIBE_TO_UNREAL_UNLIMITED, SUBSCRIBE_TO_UNREAL_UNLIMITED_SUCCESS, SUBSCRIBE_TO_UNREAL_UNLIMITED_FAIL],
        promise: function promise(client) {
          return client.post("/v1/payments/plans/switch", {
            data: { planId: "unreal-unlimited" }
          });
        }
      });
    }

    return dispatch({
      types: [SUBSCRIBE_TO_UNREAL_UNLIMITED, SUBSCRIBE_TO_UNREAL_UNLIMITED_SUCCESS, SUBSCRIBE_TO_UNREAL_UNLIMITED_FAIL],
      promise: function promise(client) {
        return client.post("/v1/payments/plans/unreal-unlimited");
      }
    });
  };
}

// Helpers

var sanitizeValues = _ramda2.default.omit(["cardNumber", "cardCvc", "cardExpiry"]);
var getCardLast4 = _ramda2.default.compose(_ramda2.default.ifElse(_ramda2.default.isNil, _ramda2.default.always(null), _ramda2.default.takeLast(4)), _ramda2.default.prop("cardNumber"));


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/payments.js
// module id = 57
// module chunks = 0